module.exports = __webpack_public_path__ + "img/KJ_currency.f429bac4.png";